import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
let inflight = null;

export function fetchSiteContent(force = false) {
  if (cache && !force) return Promise.resolve(cache);
  if (inflight && !force) return inflight;
  inflight = api
    .get("/content")
    .then((r) => {
      cache = r.data;
      inflight = null;
      return cache;
    })
    .catch(() => {
      inflight = null;
      return cache;
    });
  return inflight;
}

export async function saveSiteContent(data) {
  const res = await api.put("/content", data);
  cache = res.data;
  return cache;
}

export function useSiteContent() {
  const [content, setContent] = useState(cache);
  useEffect(() => {
    fetchSiteContent().then((c) => setContent(c));
  }, []);
  return content;
}
